import React from 'react'
import styles from './styles.module.scss'
import FooterLinksColumns from './LinksColumns'
import FooterBaseLinks from './FooterBaseLinks'
import ContactInfo from './ContactInfo'
import PaymentCardOptions from './PaymentCardOptions'
import CountrySwitcher from './CountrySwitcher'

function Footer() {
  return (
    <footer id="footer" className={styles.Footer}>
      <div className={styles.FooterContainer}>
        <div className={styles.FooterLinks}>
          <ContactInfo />
          <CountrySwitcher />
          <FooterLinksColumns />
        </div>
        <div className={styles.FooterBase}>
          <FooterBaseLinks />
          <PaymentCardOptions />
        </div>
      </div>
    </footer>
  )
}

export default Footer
